import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import LearningCourse from '../entities/article'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';
import ChapterType from '../entities/chapterType'

interface LearningCourseState extends ListState<LearningCourse> {
    editLearningCourse: LearningCourse;
    cascaders: any;
    topicCascaders: any;
    chapterTypes: any;
}
class LearningCourseModule extends ListModule<LearningCourseState, any, LearningCourse>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<LearningCourse>(),
        loading: false,
        editLearningCourse: new LearningCourse(),
        cascaders: new Array<Cascader>(),
        topicCascaders: new Array<Cascader>(),
        chapterTypes: new Array<ChapterType>()
    }
    actions = {
        async getAll(context: ActionContext<LearningCourseState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/LearningCourse/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<LearningCourse>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getAllMyselfAndChildren(context: ActionContext<LearningCourseState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/LearningCourse/GetAllMyselfAndChildren', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<LearningCourse>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }, async getAllModerated(context: ActionContext<LearningCourseState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/LearningCourse/GetAllModerated', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<LearningCourse>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<LearningCourseState, any>, payload: any) {
            await Ajax.post('/api/services/app/LearningCourse/Create', payload.data);
        },
        async update(context: ActionContext<LearningCourseState, any>, payload: any) {
            await Ajax.put('/api/services/app/LearningCourse/Update', payload.data);
        },
        async delete(context: ActionContext<LearningCourseState, any>, payload: any) {
            await Ajax.delete('/api/services/app/LearningCourse/Delete?Id=' + payload.data.id);
        },
        async auditedLearningCourse(context: ActionContext<LearningCourseState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/LearningCourse/AuditedLearningCourse', payload.data);
            context.state.loading = false;
        },
        async get(context: ActionContext<LearningCourseState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/LearningCourse/Get?Id=' + payload.data.id);
            context.state.editLearningCourse = reponse.data.result as LearningCourse;
        },
        async getCascader(context: ActionContext<LearningCourseState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: payload.data });
            context.state.cascaders = reponse.data.result as Array<Cascader>;
            context.state.loading = false;
        },
        async getChapters(context: ActionContext<LearningCourseState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ChapterType/GetList', { params: payload.data });
            context.state.chapterTypes = reponse.data.result as Array<ChapterType>;
        },

        async getupChapters(context: ActionContext<LearningCourseState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ChapterType/GetList', { params: payload.data });
            return reponse.data.result;
        }
    };
    mutations = {
        setCurrentPage(state: LearningCourseState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: LearningCourseState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: LearningCourseState, learningCourse: LearningCourse) {
            state.editLearningCourse = learningCourse;
        }
    }
}
const learningCourseModule = new LearningCourseModule();
export default learningCourseModule;